var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4182 23.6889H3.94545C1.77568 23.6889 0 21.8687 0 19.6444V7.22222C0 4.99801 1.74705 3.17778 3.91671 3.17778H5.55148C5.86193 3.17778 6.14375 3.06267 6.3408 2.83134L8.0317 1.09801C8.73625 0.404011 9.66648 0 10.6242 0H14.7106C15.6969 0 16.5985 0.403982 17.3031 1.09801L18.994 2.83134C19.191 3.03334 19.5015 3.17778 19.7833 3.17778H21.4181C23.5878 3.17778 25.3635 4.99801 25.3635 7.22222V19.6444C25.3635 21.8687 23.588 23.6889 21.4182 23.6889ZM12.6818 7.51111C9.72273 7.51111 7.32727 9.96667 7.32727 13C7.32727 16.0333 9.72273 18.4889 12.6818 18.4889C15.6409 18.4889 18.0364 16.0333 18.0364 13C18.0364 9.96667 15.6409 7.51111 12.6818 7.51111ZM12.6818 9.82222C10.9623 9.82222 9.58182 11.2373 9.58182 13C9.58182 14.7627 10.9623 16.1778 12.6818 16.1778C14.4014 16.1778 15.7818 14.7627 15.7818 13C15.7818 11.2373 14.4014 9.82222 12.6818 9.82222Z",
    fill: "#667689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.7015a8eac518ca175a6f5775509fe26a.svg";
export { ForwardRef as ReactComponent };